import React from "react";
import PropTypes from 'prop-types'
import { BgButton } from "../../pages/Theme";

const Button = ({onClick, title, style, textStyle, ...props}) => {
    return(
        <BgButton 
            className={`flex flex-row cursor-pointer rounded-lg border-2 p-1 lg:px-3 lg:py-3 
                        items-center justify-center w-flex filter drop-shadow-sm ${style}`} 
            onClick={onClick}
        >
            <div className="md:mr-2">
                {props.children}
            </div>
            
            <p className={`${"font-semibold text-xs lg:text-sm whitespace-nowrap mx-1 md:mx-2"} ${textStyle}`}>{title}</p>
        </BgButton>   
    )
}

Button.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
}

export default Button
